import {
  Box,
  Center,
  HStack,
  Icon,
  Text,
  useToast,
  VStack,
  Wrap,
} from "@chakra-ui/react";
import {
  BookOpenText,
  CheckCircle,
  Prohibit,
  Student,
  User,
  Video,
} from "@phosphor-icons/react";
import { useEffect, useState } from "react";
import ComponentSpinner from "../components/ComponentSpinner";
import ListCourseDashboard from "../components/courseComponents/ListCourseDashboard";
import ListPenggunaDashboard from "../components/courseComponents/ListPenggunaDashboard";
import ProgressCourseDashboard from "../components/courseComponents/ProgressCourseDashboard";
import NavHeader from "../components/NavHeader";
import { dashboardPenggunaCourseItemHeight } from "../const/sizes";
import cr from "../lib/request";

export default function Dashboard() {
  const [loading, setLoading] = useState<boolean>(false);
  const [data, setData] = useState<any | null>(null);
  const toast = useToast();
  useEffect(() => {
    setLoading(true);
    const url = `api/course/getsummary`;
    cr.get(url)
      .then((r) => {
        if (r.status === 200) {
          setData(r.data.data);
        }
      })
      .catch((e) => {
        console.log(e);
        toast({
          status: "error",
          title: "Terjadi Kesalahan",
          description: e?.response?.message,
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  return (
    <>
      <NavHeader label="Dashboard" />
      {loading && <ComponentSpinner />}

      {!loading && data && (
        <VStack
          w={"100%"}
          align={"stretch"}
          gap={0}
          p={5}
          bg={"var(--divider)"}
          flex={1}
        >
          <Text mb={2} fontWeight={500}>
            Total
          </Text>

          <Wrap spacing={4} mb={4}>
            <VStack
              flex={"1 1 300px"}
              p={4}
              borderRadius={8}
              align={"flex-start"}
              bg={"white"}
              position={"relative"}
              overflow={"clip"}
            >
              <Center
                p={2}
                borderRadius={8}
                bg={"var(--divider)"}
                position={"absolute"}
                bottom={0}
                right={0}
                opacity={0.1}
              >
                <Icon as={User} fontSize={72} weight="fill" />
              </Center>

              <Text>Pengguna</Text>

              <Text fontWeight={600} fontSize={32}>
                {data?.summary?.totalUsers}
              </Text>
            </VStack>

            <VStack
              flex={"1 1 300px"}
              p={4}
              borderRadius={8}
              align={"flex-start"}
              bg={"white"}
              position={"relative"}
              overflow={"clip"}
            >
              <Center
                p={2}
                borderRadius={8}
                bg={"var(--divider)"}
                position={"absolute"}
                bottom={0}
                right={0}
                opacity={0.1}
              >
                <Icon as={CheckCircle} fontSize={72} weight="fill" />
              </Center>

              <HStack>
                <Box
                  w={"10px"}
                  h={"10px"}
                  opacity={0.6}
                  bg={"green.500"}
                  borderRadius={"full"}
                />
                <Text>Pengguna Verified</Text>
              </HStack>
              <Text fontWeight={600} fontSize={32}>
                {data?.summary?.totalActiveUsers}
              </Text>
            </VStack>

            <VStack
              flex={"1 1 300px"}
              p={4}
              borderRadius={8}
              align={"flex-start"}
              bg={"white"}
              position={"relative"}
              overflow={"clip"}
            >
              <Center
                p={2}
                borderRadius={8}
                bg={"var(--divider)"}
                position={"absolute"}
                bottom={0}
                right={0}
                opacity={0.1}
              >
                <Icon as={Prohibit} fontSize={72} weight="fill" />
              </Center>

              <HStack>
                <Box
                  w={"10px"}
                  h={"10px"}
                  opacity={0.6}
                  bg={"red.500"}
                  borderRadius={"full"}
                  flexShrink={0}
                />
                <Text>Pengguna Tidak Verified</Text>
              </HStack>
              <Text fontWeight={600} fontSize={32}>
                {data?.summary?.totalNonActiveUsers}
              </Text>
            </VStack>

            <VStack
              flex={"1 1 300px"}
              p={4}
              borderRadius={8}
              align={"flex-start"}
              bg={"white"}
              position={"relative"}
              overflow={"clip"}
            >
              <Center
                p={2}
                borderRadius={8}
                bg={"var(--divider)"}
                position={"absolute"}
                bottom={0}
                right={0}
                opacity={0.1}
              >
                <Icon as={Student} fontSize={72} weight="fill" />
              </Center>

              <Text>Course</Text>
              <Text fontWeight={600} fontSize={32}>
                {data?.summary?.totalCourses}
              </Text>
            </VStack>

            <VStack
              flex={"1 1 300px"}
              p={4}
              borderRadius={8}
              align={"flex-start"}
              bg={"white"}
              position={"relative"}
              overflow={"clip"}
            >
              <Center
                p={2}
                borderRadius={8}
                bg={"var(--divider)"}
                position={"absolute"}
                bottom={0}
                right={0}
                opacity={0.1}
              >
                <Icon as={Video} fontSize={72} weight="fill" />
              </Center>

              <Text>Bergabung Course</Text>
              <Text fontWeight={600} fontSize={32}>
                {data?.summary?.totalParticipant}
              </Text>
            </VStack>

            <VStack
              flex={"1 1 300px"}
              p={4}
              borderRadius={8}
              align={"flex-start"}
              bg={"white"}
              position={"relative"}
              overflow={"clip"}
            >
              <Center
                p={2}
                borderRadius={8}
                bg={"var(--divider)"}
                position={"absolute"}
                bottom={0}
                right={0}
                opacity={0.1}
              >
                <Icon as={BookOpenText} fontSize={72} weight="fill" />
              </Center>

              <Text>Blog Post</Text>
              <Text fontWeight={600} fontSize={32}>
                {data?.summary?.totalBlogPost}
              </Text>
            </VStack>
          </Wrap>

          <Text mb={2} fontWeight={500}>
            Course & Pengguna Course
          </Text>

          <Wrap spacing={4}>
            <ListCourseDashboard
              data={data.courses}
              h={dashboardPenggunaCourseItemHeight}
              flex={"1 1 300px"}
            />

            <ListPenggunaDashboard
              h={dashboardPenggunaCourseItemHeight}
              data={data.users.activeUsers}
              minH={"300px"}
              title={"Pengguna Verified"}
              status={"aktif"}
              flex={"1 1 300px"}
            />

            <ListPenggunaDashboard
              h={dashboardPenggunaCourseItemHeight}
              data={data.users.nonActiveUsers}
              minH={"300px"}
              title={"Pengguna Tidak Verified"}
              status={"tidak aktif"}
              flex={"1 1 300px"}
            />

            <ProgressCourseDashboard
              minH={"300px"}
              data={data.participant.percentage}
              dataCount={data.participant.count}
              flex={"1 1 0"}
            />
          </Wrap>
        </VStack>
      )}
    </>
  );
}
